//====================================================
//  Initialization Wow
//====================================================
function fn_components_wow(){
	new WOW().init();
}
